import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=1aec095c&scoped=true"
import script from "./previewImg.vue?vue&type=script&lang=ts"
export * from "./previewImg.vue?vue&type=script&lang=ts"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=1aec095c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec095c",
  null
  
)

export default component.exports